
import {
    Button,
    Col,
	Container,
    Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
    Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'

const MissingPricesModal = ({ openMissingPricesModal, setOpenMissingPricesModal, priceValidationMessages }) =>
{
    const { t } = useTranslation()

    return (
        <>
            <Modal
				isOpen={ openMissingPricesModal }
				toggle={ () => setOpenMissingPricesModal(false) }
			>
				<ModalHeader toggle={ () => setOpenMissingPricesModal(false) } charCode="Y">
					{ t('Auctions.Vehicle.Missing_Prices') }
				</ModalHeader>
                <ModalBody>
					<Container fluid>
						<div className="modal-body">
							<table>
								<tbody className="list">
								{
									priceValidationMessages.map((priceValidationMessage) => (
										<tr><td>{ priceValidationMessage }</td></tr>
									))
								}
								</tbody>
							</table>
						</div>
					</Container>
                </ModalBody>
				<ModalFooter>
					<Row>
						<Col md={12}>
							<Button color="danger" type="button" className="btn-block" onClick={ () => setOpenMissingPricesModal(false) }>
								{ t('Common.Okay') }
							</Button>
						</Col>
					</Row>
				</ModalFooter>
            </Modal>
        </>
    )
}

export default MissingPricesModal
